/**
 * Data Transfer Object for deleting a material
 */
import { MaterialValidationMessages } from '../enums';

export class DeleteMaterialDTO {
    constructor(id) {
        this.id = id;
    }

    /**
     * Validate the DTO before submission
     * @returns {{valid: boolean, error?: string}}
     */
    validate() {
        if (!this.id) {
            return {
                valid: false,
                error: MaterialValidationMessages.ID_REQUIRED
            };
        }

        return { valid: true };
    }

    /**
     * Get the material ID
     * @returns {string|number}
     */
    getId() {
        return this.id;
    }
}
